import { GET } from "./api";

export const Read = async () => {
  return await GET(`/data-base`, true, true);
}